/* ---------------------------------------------------------------------------
	VSonner

 // import toaster from "@/utils/toaster.js";と記載します。
 // 次に使用したい処理を下記のように指定します。
 // const { alert } = toaster();
 // 例）toasterAlert("/account/${id}/edit", serachDate, list);
---------------------------------------------------------------------------- */

import { toast } from "vuetify-sonner";
import "vuetify-sonner/style.css";

export default function toaster() {
	/* ---------------------------------------------------------------------------
  ページ遷移
  ---------------------------------------------------------------------------- */
	function alert(flag) {
		/* --------------------------------------------------------------
		成功
		----------------------------------------------------------------- */
		if (flag == "normal") {
			toast("ここに見出しが表示されます", {
				position: "bottom-right",
				description: "ここにメッセージが表示されます"
			});
		}
		if (flag == "login") {
			toast.success("Success !!", {
				position: "bottom-right",
				description: "システムにログインしています。"
			});
		}

		if (flag == "logout") {
			toast.success("Success !!", {
				position: "bottom-right",
				description: "システムからログアウトしています。"
			});
		}

		if (flag == "store") {
			toast.success("Success !!", {
				position: "bottom-right",
				description: "登録処理が完了しました。"
			});
		}

		if (flag == "update") {
			toast.success("Success !!", {
				position: "bottom-right",
				description: "更新処理が完了しました。"
			});
		}

		if (flag == "forgot") {
			toast.success("Success !!", {
				position: "bottom-right",
				description: "パスワードリセットのメールが送信されました。"
			});
		}

		if (flag == "delete") {
			toast.success("Success !!", {
				position: "bottom-right",
				description: "データを削除しました。"
			});
		}

		if (flag == "copy") {
			toast.success("Success !!", {
				position: "bottom-right",
				description: "ダウンロードリンクをコピーしました。"
			});
		}

		if (flag == "download") {
			toast.success("Success !!", {
				position: "bottom-right",
				description: "ファイルをダウンロードしました。"
			});
		}

		if (flag == "resendCode") {
			toast.success("Success !!", {
				position: "bottom-right",
				description: "認証コードを再送信しました。"
			});
		}

		if (flag == "verify") {
			toast.success("Success !!", {
				position: "bottom-right",
				description: "認証を確認しました。"
			});
		}

		if (flag == "send") {
			toast.success("Success !!", {
				position: "bottom-right",
				description: "招待メールを送信しました。"
			});
		}

		/* --------------------------------------------------------------
		その他
		----------------------------------------------------------------- */
		if (flag == "info") {
			toast.info("Info !!", {
				position: "bottom-right",
				description: "追加情報があります。"
			});
		}

		if (flag == "warning") {
			toast.warning("Warning !!", {
				position: "bottom-right",
				description: "処理が完了しましたが、問題が発生しました。"
			});
		}

		/* --------------------------------------------------------------
		失敗
		----------------------------------------------------------------- */
		if (flag == "error_login") {
			toast.error("Error !!", {
				position: "bottom-right",
				description: "ログインが失敗しました。"
			});
		}

		if (flag == "error_store") {
			toast.error("Error !!", {
				position: "bottom-right",
				description: "登録処理が失敗しました。"
			});
		}

		if (flag == "error_update") {
			toast.error("Error !!", {
				position: "bottom-right",
				description: "更新処理が失敗しました。"
			});
		}

		if (flag == "error_forgot") {
			toast.error("Error !!", {
				position: "bottom-right",
				description: "パスワードリセットが失敗しました。"
			});
		}

		if (flag == "error_reset") {
			toast.error("Error !!", {
				position: "bottom-right",
				description: "パスワードの再設定が失敗しました。"
			});
		}

		if (flag == "error_delete") {
			toast.error("Error !!", {
				position: "bottom-right",
				description: "データの削除が失敗しました。"
			});
		}
	}
	/* ---------------------------------------------------------------------------
  return
  ---------------------------------------------------------------------------- */
	return {
		alert
	};
}
